module.exports = __webpack_public_path__ + "img/home-img.a0b01dc8.jpg";